import React, { useEffect, useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import {
  MenuItem,
  Select,
  TableSortLabel,
  SvgIcon,
  Button,
} from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import toast, { Toaster } from "react-hot-toast";
import { GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";
import FilterListSharpIcon from "@material-ui/icons/FilterListSharp";

import { useHistory, useLocation, Link } from "react-router-dom";
import {
  getDate,
  viewMitsChildReportsPath,
  searchFilter,
  handleSort,
  getToday,
  getTime,
  editProspectPath,
  getDateTime,
  get12HoursTime,
  createAdviseRequestPath,
  AddAdviseRequestPath,
  rebalance_sell_path,
} from "../utils/varialbles";
import http from "../services/httpService";
import SearchBar from "material-ui-search-bar";
// import Filter from '../components/filerComponent';
import filterData from "../components/filterCriteria";
// import useFilter from "../components/filterComponent";
// import useFilter from "../components/multifilterComponent";
import useFilter from "../components/sideFilter";
// import { browserHistory } from 'react-router'
import { browserHistory } from "react-router-dom";
import { createHashHistory } from "history";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";

const anchorEl = 1;
const setAnchorEl = 2;

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  table: {
    field: "Resizing",
    title: "Column Width",
    cellStyle: {
      whiteSpace: "nowrap",
      width: "20%",
    },
  },
  tableRow: {
    "&:hover": {
      cursor: "pointer",
    },
  },
  indeterminateColor: {
    color: "#f50057",
  },
  selectAllText: {
    fontWeight: 500,
  },
  selectedAll: {
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.08)",
    },
  },
  radio: {
    "&$checked": {
      color: "#57bf74",
    },
  },
  checked: {},
});

export default function AdviceRequests() {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState([]);
  const [searched, setSearched] = useState("");
  const [orignalRows, setOriginalRows] = useState([]);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");
  const [totalRowCount, setTotalRowCount] = useState(0);
  let history = useHistory();
  const [columns, setColumns] = useState([
    {
      headerName: "ID",
      id: "reqid",
      show: true,
      minWidth: 150,
    },
    {
      headerName: "Name",
      id: "name",
      show: true,
      minWidth: 150,
    },
    {
      headerName: "User ID",
      id: "userid",
      show: true,
      minWidth: 150,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "EFG",
      id: "efg",
      show: true,
      minWidth: 100,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Mobile Number",
      id: "mobile",
      show: true,
      minWidth: 150,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Date Of Request",
      id: "date",
      show: true,
      minWidth: 200,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Country Of Investment",
      id: "country",
      show: true,
      minWidth: 200,
      type: "array",
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Investment Amount",
      id: "amount",
      show: true,
      minWidth: 150,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "ELSS",
      id: "elss",
      show: true,
      minWidth: 200,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Frequency Of Request",
      id: "freq",
      show: true,
      minWidth: 200,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Type",
      id: "type",
      show: true,
      minWidth: 200,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Filter Type",
      id: "filter_type",
      show: true,
      minWidth: 200,
      // headerAlign: "center",
      // align: "center",
    },
  ]);

  const getPaginationURL = (url, newQuery) => {
    const query = newQuery === "" ? newQuery : searched;
    if (query) {
      return `${url}?page=${
        page + 1
      }&rowsPerPage=${rowsPerPage}&search=${query}`;
    } else {
      return `${url}?page=${page + 1}&rowsPerPage=${rowsPerPage}`;
    }
  };

  const requestSearch = (searchedVal) => {
    let rowsTemp = [...rows];
    setPage(0);
    setOriginalRows(searchFilter(searchedVal, rowsTemp));
  };
  const cancelSearch = () => {
    // getData();
    setSearched("");
    requestSearch(searched);
  };

  useEffect(() => {
    getData();

    localStorage.setItem("adviserowsperpage", rowsPerPage);
    localStorage.removeItem("investmentFilter");
    localStorage.removeItem("prospectFilter");
    localStorage.removeItem("ticketFilter");
    localStorage.removeItem("internalFilter");
    localStorage.removeItem("prospectFilter");
    localStorage.removeItem("selectedinvestorfiltersdata");
  }, [page, rowsPerPage]);

  const getData = (newQuery) => {
    const baseURL = "/invreqs_pending";
    toast.loading("Please wait...");
    setOriginalRows([]);
    setRows([]);
    // .get("/invreqs_pending")
    http.get(getPaginationURL(baseURL, newQuery)).then((response) => {
      toast.dismiss();
      if (
        response &&
        response.data &&
        response.data.statusCode === 0 &&
        Array.isArray(response.data.Data)
      ) {
        // ("ooooooo");

        let tempDta = response.data.Data;

        setRows(response.data.Data);

        // setTotalRowCount(response.data.totalRowCount);

        let finalrows = tempDta.map((item) => {
          // (item);
          const obj = item;
          // (obj);

          const swapValue = (obj) => {
            Object.keys(obj).forEach((key) => {
              // if (!obj[key]) {
              //     obj[key] = "N/A";
              // }
            });
          };
          swapValue(obj);
          // (obj);
          return item;
        });

        let tempRows = [];
        // let tempTasks = tempDta.map(item=>item.custtasks);
        // setCustTask(tempTasks);

        let finalData = [];
        let tempStatusDta = tempDta.map((item, index) => {
          const swapValue = (item) => {
            Object.keys(item).forEach((key) => {
              //(Object.keys(item));
              // if (!item[key]) {
              //     item[key] = "N/A";
              // }
            });
          };
          swapValue(item);
          finalData.push((item.date = getDateTime(item.date)));
          if (item.country.length !== 0) {
            finalData.push(item.country);
          } else {
            finalData.push(item.country);
          }
          if (item.elss === null) {
            finalData.push((item.elss = "N/A"));
          } else {
            finalData.push(item.elss);
          }

          if (item.cagr === null) {
            finalData.push((item.cagr = "N/A"));
          } else {
            finalData.push(item.cagr);
          }
          if (!item.name) {
            finalData.push((item.name = "N/A"));
          } else {
            finalData.push(item.name);
          }

          if (item.filter_type === null) {
            finalData.push((item.filter_type = "N/A"));
          } else {
            finalData.push(item.filter_type);
          }

          finalData.push(
            (item.cust__createddt = getDateTime(item.cust__createddt))
          );
          finalData.push(
            (item.cust__last_login = getDateTime(item.cust__last_login))
          );
          finalData.push((item.custtasks = getDateTime(item.custtasks)));

          return item;
        });

        // setOriginalRows(tempDta.slice().reverse());
        setOriginalRows(tempDta);
        setRows(tempDta);
        setTotalRowCount(response.data.totalRowCount);
      } else {
        setOriginalRows([]);
        setRows([]);
        setTotalRowCount(0);
      }
    });
  };

  let filteredCol = columns.filter((data) => {
    if (data.show) {
      return data;
    }
  });

  const handleChangePage = (event, newPage) => {
    // (newPage);
    setPage(newPage);
  };

  const handleRequestSort = (e, property, format) => {
    let isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    let tempRows = [...rows];
    let finalRows = handleSort(property, format, tempRows, isAsc);
    setRows(finalRows);
    setPage(0);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const viewProspectDetails = (object) => {
    object.page = page;
    history.push(
      {
        pathname: createAdviseRequestPath,
        state: object,
      },
      "_blank"
    );
  };

  const gotoAddAdvice = (e) => {
    e.preventDefault();
    history.push({
      pathname: AddAdviseRequestPath,
    });
  };

  const gotoRebalance = (e) => {
    e.preventDefault();
    history.push({
      pathname: rebalance_sell_path,
    });
  };

  return (
    <>
      <div style={{ marginBottom: "10px" }}>
        <Button
          variant="contained"
          color="primary"
          style={{
            //   background: "#2835d5",
            //   color: "#fff",
            borderRadius: 30,
            //   textAlign: "center",
            //   border: "1px solid transparent",
            //   padding: "5px 10px",
            //   cursor: "pointer",
            //   fontSize: 16,
          }}
          onClick={(e) => gotoAddAdvice(e)}
        >
          <AddCircleOutlineIcon
            style={{ verticalAlign: "middle", paddingRight: 7 }}
          />
          Add Advise
        </Button>

        <Button
          variant="contained"
          color="primary"
          style={{
            //   background: "#2835d5",
            //   color: "#fff",
            borderRadius: 30,
            //   textAlign: "center",
            //   border: "1px solid transparent",
            //   padding: "5px 10px",
            //   cursor: "pointer",
            //   fontSize: 16,
            marginLeft: 20,
          }}
          onClick={(e) => gotoRebalance(e)}
        >
          <AddCircleOutlineIcon
            style={{ verticalAlign: "middle", paddingRight: 7 }}
          />
          Add Rebalance Advice
        </Button>
      </div>
      <Paper className={classes.root}>
        <div className="prospectsearchfilterboth">
          <div className="prospectsearch">
            <SearchBar
              value={searched}
              onChange={(searchVal) => requestSearch(searchVal)}
              onCancelSearch={() => cancelSearch()}
              style={{ height: "unset", padding: 5 }}
            />
          </div>

          <div>
            <TablePagination
              rowsPerPageOptions={[10, 50, 100, 500]}
              component="div"
              count={totalRowCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        </div>

        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                {filteredCol.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                    className="prospect_table"
                  >
                    {/* <TableSortLabel
                      active={orderBy === column.id}
                      direction={orderBy === column.id ? order : "asc"}
                      onClick={(e) =>
                        handleRequestSort(e, column.id, column.format)
                      }
                    >
                    </TableSortLabel> */}
                    {column.headerName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {orignalRows.length !== 0 ? (
                <>
                  {orignalRows.map((row, index) => {
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={index + "a"}
                        className="prospecttable"
                      >
                        {filteredCol.map((column, index) => {
                          const value = row[column.id];

                          return (
                            <TableCell
                              key={index + column.id}
                              align={column.align}
                              onDoubleClick={() => viewProspectDetails(row)}
                            >
                              {column.format && typeof value === "number" ? (
                                column.format(value)
                              ) : column.id === "country" &&
                                value.length !== 0 ? (
                                <>
                                  {Array.isArray(value)
                                    ? value.join(",  ")
                                    : value}
                                </>
                              ) : column.format === "Date" ? (
                                getDate(value)
                              ) : column.operation &&
                                column.operation === "concate" ? (
                                value + column.operand + row[column.with]
                              ) : column.type &&
                                column.type === "link" &&
                                value ? (
                                <Link
                                  variant="body2"
                                  // onClick={(e) => viewDetails(row)}
                                  onClick={(e) => viewProspectDetails(row)}
                                  gutterBottom
                                  style={{ cursor: "pointer" }}
                                >
                                  {value}
                                </Link>
                              ) : column.type &&
                                column.type === "attach" &&
                                value ? (
                                <Link
                                  // href={staticFiles + value}
                                  target="_blank"
                                  variant="body2"
                                  gutterBottom
                                  style={{ cursor: "pointer" }}
                                >
                                  {value}
                                </Link>
                              ) : (
                                // ) : column.headerName === "EFG" && value ? (
                                //   <>{value}</>
                                value
                              )}
                            </TableCell> //headerName: "EFG"
                          );
                        })}
                      </TableRow>
                    );
                  })}
                </>
              ) : (
                <TableCell
                  colspan="6"
                  style={{ "text-align": "center", margin: "10px 0px" }}
                >
                  Data Not Available
                </TableCell>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <div>
          <TablePagination
            rowsPerPageOptions={[10, 50, 100, 500]}
            component="div"
            count={totalRowCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </Paper>
    </>
  );
}
